import ButtonCTA from '@/components/base/ButtonCTA';
import ButtonWhatsApp from '@/components/base/ButtonWhatsApp';
import ButtonPhone from '@/components/base/ButtonPhone';

interface CTABlockProps {
  title?: string;
  showDevis?: boolean;
  showWhatsApp?: boolean;
  showPhone?: boolean;
  devisLabel?: string;
  devisHref?: string;
  whatsAppLabel?: string;
}

export default function CTABlock({
  title = 'Un doute ? Envoyez une photo sur WhatsApp, on vous répond en 2 h.',
  showDevis = true,
  showWhatsApp = true,
  showPhone = true,
  devisLabel = 'Devis gratuit',
  devisHref,
  whatsAppLabel = 'WhatsApp direct',
}: CTABlockProps) {
  return (
    <div className="w-full bg-primary-500 py-14 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-white mb-8">
          {title}
        </h2>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 flex-wrap">
          {showDevis && (
            <ButtonCTA href={devisHref}>
              {devisLabel}
            </ButtonCTA>
          )}
          {showWhatsApp && (
            <ButtonWhatsApp>
              {whatsAppLabel}
            </ButtonWhatsApp>
          )}
          {showPhone && (
            <ButtonPhone />
          )}
        </div>
      </div>
    </div>
  );
}